var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "confirm-print_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469",
    stopOpacity: 0.219
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confirm-print_svg__b",
    x1: "30.676%",
    x2: "69.324%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confirm-print_svg__c",
    x1: "0%",
    x2: "100%",
    y1: "84.722%",
    y2: "15.278%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "confirm-print_svg__d",
    x1: "0%",
    x2: "100%",
    y1: "54.056%",
    y2: "45.944%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#confirm-print_svg__a)",
    rx: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.889 28.333c0 .245.2.445.444.445h17.334c.244 0 .444-.2.444-.445V16.578H11.89v11.755zm7.133-10.177l5.49 5.088-2.468-.066L23.29 26c.155.378-.022.844-.4 1a.785.785 0 01-1-.4l-1.222-2.8-1.69 1.844.045-7.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M12.956 14.378c-.267 0-.467.2-.467.466a.47.47 0 00.467.467c.266 0 .466-.2.466-.467 0-.266-.2-.466-.466-.466zm1.288 0c-.266 0-.466.2-.466.466 0 .267.2.467.466.467.267 0 .467-.2.467-.467 0-.266-.2-.466-.467-.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#confirm-print_svg__b)",
    d: "M10.889 13.6a.785.785 0 001 .4c.378-.156.555-.622.4-1l-1.245-2.822 2.467.066-5.489-5.088-.044 7.488L9.667 10.8l1.222 2.8z",
    transform: "translate(11 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#confirm-print_svg__c)",
    d: "M18.667 0H1.333C.6 0 0 .6 0 1.333v14c0 .734.6 1.334 1.333 1.334h17.334c.733 0 1.333-.6 1.333-1.334v-14C20 .6 19.4 0 18.667 0zm.444 15.333c0 .245-.2.445-.444.445H1.333a.446.446 0 01-.444-.445V3.578H19.11v11.755zm0-12.644H.89V1.333c0-.244.2-.444.444-.444h17.334c.244 0 .444.2.444.444V2.69z",
    transform: "translate(11 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M15.533 14.378c-.266 0-.466.2-.466.466 0 .267.2.467.466.467.267 0 .467-.2.467-.467 0-.266-.2-.466-.467-.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#confirm-print_svg__d)",
    d: "M1.956 2.378c-.245 0-.467-.215-.467-.5 0-.286.2-.5.467-.5.266 0 .466.214.466.5 0 .285-.2.5-.466.5zm1.288 0c-.266 0-.466-.215-.466-.5 0-.286.2-.5.466-.5.267 0 .467.214.467.5 0 .285-.2.5-.467.5zm1.29 0c-.267 0-.467-.215-.467-.5 0-.286.2-.5.466-.5.267 0 .467.214.467.5 0 .285-.2.5-.467.5z",
    transform: "translate(11 13)"
  }))));
}
export default SvgConfirmPrint;